// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bep_a bii_ea bii_ke bii_ju bii_sn bii_wl"};